import React from 'react';
import { ErrorPage } from '../containers/ErrorPage';
import { MetaAttributes } from '../head';

const NotFoundPage = () => {
  return (
    <>
      <MetaAttributes seoTitle={'Error | Ollie'} />
      <ErrorPage statusCode={404} />
    </>
  );
};

export default NotFoundPage;
